// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-footer[data-v-51dcae3e]{position:relative;background-color:#1f2430;color:#fff;overflow:hidden}.app-footer__container[data-v-51dcae3e]{position:relative;max-width:62.5rem;padding:80px 0}.app-footer__container a[data-v-51dcae3e]{text-decoration:underline}.app-footer__container a[data-v-51dcae3e]:hover{color:#fff;text-decoration:none}", ""]);
// Exports
module.exports = exports;
